module.exports = (selectors...)=>
  tag = null
  for selector in selectors
    tag = document.querySelector(selector) || document.querySelector('[riot-tag="' + selector + '"]')
    break if tag?

  return tag